import * as Yup from "yup";

export const ApplicationValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string(),
    uri: Yup.string()
        .url("Valid URL is required")
        .required("A valid URL is required."),
});

export const ApplicationObjectSchema = {
    name: "",
    description: "",
    id: "",
    uri: "",
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let app = Object.assign({}, ApplicationObjectSchema, {
        id: parseInt(requestData.id),
        name: requestData.name,
        description: requestData.description,
        uri: requestData.uri,
        active: requestData.active,
    });

    return app;
}
